<template>
<span>
    <slot/>
</span>
</template>

<script>
import { requestCurrentPosition, getDistance } from '@/utils/position';

export default {
    props: {
        longitude: {
            required: true,
            type: String,
            _descr: 'longitude',
        },
        latitude: {
            required: true,
            type: String,
            _descr: 'latitude',
        },
        units: {
            required: true,
            type: String,
            validator: value => ['km', 'mi'].includes(value),
            _descr: 'units of distance',
        },
    },
    data () {
        return {
            purpose: 'for-value-node', // ancor for value tag,
        };
    },
    computed: {
        value () {
            if (!this.$root.appConfig.geoLocation) {
                return null;
            }

            if (this.$root.appConfig.geoLocation.pending) {
                return undefined;
            }

            let meters = getDistance({
                latitude: this.latitude,
                longitude: this.longitude,
            }, this.$root.appConfig);

            const METERS_IM_MILE = 1609.34;
            const METERS_IM_KILOMETER = 1000;

            return (this.units === 'mi' ? meters / METERS_IM_MILE : meters / METERS_IM_KILOMETER);
        },
    },
    mounted () {
        requestCurrentPosition(this.$root.appConfig);
    },
};
</script>
